<template>
	<div class="form-header" :class="{'is-stuck': isScrolling}">
		<div class="form-header-inner">
			<div class="left">
				<h3>{{ titleHeader }}</h3>
			</div>
			<div class="buttons">
				<vs-button color="danger" @click.prevent="onCancel">{{ cancelText }}</vs-button>
				<vs-button :disabled="disabledSave" @click.prevent="onSave">{{ saveText }}</vs-button>
			</div>
		</div>
	</div>
</template>

<script>
import windowScrollPosition from "@/plugins/window-scroll-position.js";

export default {
	mixins: [windowScrollPosition("position")],
	props: {
		disabledSave: {
			type: Boolean,
			default: false,
		},
		titleHeader: {
			type: String,
			default: "",
		},
		saveText: {
			type: String,
			default: "Guardar",
		},
		cancelText: {
			type: String,
			default: "Cancelar",
		},
	},
	computed: {
		isScrolling() {
			return this.position[1] > 30;
		},
	},
	methods: {
		onCancel() {
			this.$emit("cancel");
		},
		onSave() {
			this.$emit("save");
		},
	},
};
</script>

<style lang="scss" scoped>
.form-header {
	padding: 5px 20px;
	transition: all 0.3s ease;
	z-index: 41000 !important;

	&.is-stuck {
		position: fixed;
		top: 60px;
		left: 80px;
		width: calc(100% - 80px);
		background-color: white;
		border-left: 1px solid #ccc;
		border-bottom: 4px solid rgba(var(--vs-primary), 1);
		box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
		z-index: 1000;
	}

	.form-header-inner {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.left h3 {
		font-family: var(--font-alt);
		font-size: 1.3rem;
		font-weight: 700;
		color: #333333;
	}

	.buttons {
		display: flex;
		gap: 15px;
		.vs-button {
			padding: 10px 20px;
			font-size: 1rem;
			font-weight: 600;
			transition: background-color 0.3s ease;
			&.mr-3 {
				margin-right: 15px;
			}
		}
	}
}
/* Media Queries */
@media (max-width: 1200px) {
	.form-header {
		padding: 14px 20px;
		&.is-stuck {
			left: 0;
			width: 100%;
		}
		.left h3 {
			font-size: 1.3rem;
		}

		.buttons .vs-button {
			padding: 8px 18px;
			font-size: 0.95rem;
		}
	}
}

@media (max-width: 992px) {
	.form-header {
		padding: 12px 18px;

		.left h3 {
			font-size: 1.2rem;
		}

		.buttons .vs-button {
			padding: 7px 16px;
			font-size: 0.9rem;
		}
	}
}

@media (max-width: 768px) {
	.form-header {
		padding: 10px 16px;

		.left h3 {
			font-size: 1.1rem;
		}

		.buttons {
			gap: 10px;
			.vs-button {
				padding: 6px 14px;
				font-size: 0.85rem;
			}
		}
	}
}

@media (max-width: 576px) {
	.form-header {
		padding: 8px 14px;

		.left h3 {
			font-size: 1rem;
		}

		.buttons {
			flex-direction: column;
			gap: 8px;

			.vs-button {
				width: 100%;
				padding: 8px 12px;
				font-size: 0.9rem;
				text-align: center;
			}
		}
	}
}
</style>
